import styled from "styled-components";

import { BaseFlex, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Wrapper = styled(FlexColumn)`
    position: relative;
    height: 680px;
`;

export const ContentWrapper = styled(BaseFlex)`
    justify-content: space-between;
    overflow: hidden;
    height: 100%;
`;

export const TitleWrapper = styled(FlexColumn)`
    gap: 8px;
`;
